mutation DeleteRevitParameterTemplate(
    $id: ID!
) {
    deleteRevitParameterTemplate(
        id: $id
    )
}
